export default "__VITE_ASSET__CHO3_IHa__"